<template>
  <span class="small" :class="textClass"><i :class="icon"></i> {{ text }}</span>
</template>
<script>
export default {
  name: 'AccountLevelStatus',
  props: {
    status: {
      type: String
    }
  },
  computed: {
    text() {
      switch(this.status) {
        case 'Active':
          return 'ใช้งาน'
        break
        case 'Inactive':
          return 'ยกเลิก'
        break
      }
    },
    textClass() {
      switch(this.status) {
        case 'Active':
          return 'text-success'
        break
        case 'Inactive':
          return 'text-secondary'
        break
      }
    },
    icon() {
      switch(this.status) {
        case 'Active':
          return 'fas fa-circle'
        break
        case 'Inactive':
          return 'fas fa-ban'
        break
      }
    }
  }
}
</script>
